<template>
  <div class="isolate">
    <ProductJapan v-if="isJapanProductPage" />
    <ProductGlobal v-else />
  </div>
</template>

<script setup lang="ts">
import { showError } from '#imports'
import { computed, defineAsyncComponent } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

const ProductGlobal = defineAsyncComponent(
  () =>
    import(
      '~/scopes/product-core/pages/ProductDetailPage/global/GlobalProductDetailPage.vue'
    ),
)
const ProductJapan = defineAsyncComponent(
  () =>
    import(
      '~/scopes/product-core/pages/ProductDetailPage/jp/JPProductDetailPage.vue'
    ),
)

if (!import.meta.dev) {
  showError({
    fatal: true,
    status: 404,
    statusText: 'Page Not Found',
    message: 'This page is only available in development mode',
  })
}

const { market } = useMarketplace()

const isJapanProductPage = computed(
  () => market.countryCode === MarketCountryCode.JP,
)
</script>
